import React from "react";
import { Clock, MapPin, ArrowUpRight, CalendarDays } from "lucide-react";
import { DiamondBorder, SectionLabel } from "./AipanPattern";
import { EVENTS } from "../mock";

export default function Events() {
  return (
    // <section className="py-20 pb-20 bg-[var(--paper)] paper-grain -mt-[100px]">
//    <section
//   id="about"
//   className="relative pt-8 pb-8 bg-[var(--paper)] paper-grain"
// >
//       <div className="max-w-7xl mx-auto px-6">
//         <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
//           <div>
//             <SectionLabel>Events</SectionLabel>
//             {/* <h2 className="mt-5 font-display text-[38px] lg:text-[48px] font-bold">
//               Lectures. Concerts. <br /><span className="italic text-[var(--terracotta)]">Convocations.</span>
//             </h2> */}
//           </div>
//           {/* <a href="#" className="btn-outline self-start md:self-end">
//             <CalendarDays size={16} /> Full calendar
//           </a> */}
//         </div>

//         <DiamondBorder className="my-4" />

//         <div className="grid md:grid-cols-2 gap-5">
//           {EVENTS.map((e, i) => (
//             <article
//               key={i}
//               className="group relative rounded-2xl bg-white border border-[var(--cream-deep)] p-6 card-lift overflow-hidden"
//             >
//               <div className="flex gap-5">
//                 <div className="shrink-0 w-20 text-center rounded-xl bg-gradient-to-b from-[var(--terracotta)] to-[var(--terracotta-deep)] text-white p-3 shadow-lg">
//                   <div className="text-[11px] tracking-[0.2em] uppercase opacity-80">{e.month}</div>
//                   <div className="font-display text-[38px] leading-none mt-0.5">{e.day}</div>
//                   <div className="text-[11px] opacity-80 mt-1">{e.year}</div>
//                 </div>
//                 <div className="flex-1">
//                   <h3 className="font-display font-bold text-[19px] leading-snug text-[var(--ink)] group-hover:text-[var(--terracotta)] transition-colors">
//                     {e.title}
//                   </h3>
//                   <div className="mt-3 space-y-1.5 text-[13px] text-[var(--ink)]/70">
//                     <div className="inline-flex items-center gap-2"><Clock size={13} className="text-[var(--saffron)]" /> {e.time}</div>
//                     <div className="inline-flex items-center gap-2"><MapPin size={13} className="text-[var(--pine)]" /> {e.venue}</div>
//                   </div>
//                   {/* <a href="#" className="mt-4 inline-flex items-center gap-1.5 text-[13px] font-semibold text-[var(--terracotta)] link-sweep">
//                     Event details <ArrowUpRight size={14} />
//                   </a> */}
//                 </div>
//               </div>
//             </article>
//           ))}
//         </div>
//       </div>
//     </section>
<></>
  );
}
